import React from 'react';
import { Button } from './ui/Button';
import { Check, FileText, ListChecks, CalendarDays, ShieldAlert, Utensils, Dumbbell } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const features = [{
    icon: FileText,
    text: 'The full PDF ebook (readable, scannable)'
  }, {
    icon: ListChecks,
    text: 'Phase-Proof checklists'
  }, {
    icon: Utensils,
    text: 'Food Anchor templates'
  }, {
    icon: Dumbbell,
    text: 'Training Swap cards (Green/Yellow/Red)'
  }, {
    icon: ShieldAlert,
    text: 'Calendar Protection scripts'
  }, {
    icon: CalendarDays,
    text: 'Printable 28-day planner (reusable)'
  }];
  return <section id="pricing" className="py-20 px-4 sm:px-6 max-w-5xl mx-auto" data-id="element-71">
      <div className="bg-white rounded-3xl shadow-xl shadow-[#4A2C40]/5 overflow-hidden border border-[#4A2C40]/10" data-id="element-72">
        <div className="grid md:grid-cols-2" data-id="element-73">
          {/* Left: Value Stack */}
          <div className="p-8 md:p-12 bg-[#F3EFE7]/30" data-id="element-74">
            <h3 className="text-2xl font-serif font-bold text-[#4A2C40] mb-8" data-id="element-75">
              What's Inside The Kit
            </h3>
            <ul className="space-y-6" data-id="element-76">
              {features.map((feature, i) => <li key={i} className="flex items-start gap-4" data-id="element-77">
                  <div className="bg-[#F3EFE7] p-2 rounded-lg text-[#4A2C40]" data-id="element-78">
                    <feature.icon className="h-5 w-5" data-id="element-79" />
                  </div>
                  <span className="text-[#4A2C40] font-medium pt-1.5" data-id="element-80">
                    {feature.text}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right: Offer */}
          <div id="pricing-cta" className="p-8 md:p-12 flex flex-col justify-center bg-white relative" data-id="element-81">
            <div className="absolute top-0 right-0 bg-[#4A2C40] text-[#FDFBF7] text-xs font-bold px-4 py-2 rounded-bl-xl" data-id="element-82">
              INSTANT ACCESS
            </div>

            <div className="text-center mb-8" data-id="element-83">
              <p className="text-[#4A2C40]/60 font-medium mb-2" data-id="element-84">
                Total Value: Peace of Mind
              </p>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-85">
                <span className="text-2xl font-serif text-[#4A2C40]/40 line-through" data-id="element-86">
                  $14.39
                </span>
                <span className="text-5xl font-serif font-bold text-[#4A2C40]" data-id="element-87">
                  $6.39
                </span>
              </div>
              <div className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-88">
                SAVE 56% TODAY
              </div>
              <p className="text-sm text-[#4A2C40]/80 max-w-xs mx-auto" data-id="element-89">
                Less than the cost of the takeout you order when you're too
                tired to cook.
              </p>
            </div>

            <Button size="lg" fullWidth className="mb-4 text-lg h-16 shadow-xl shadow-[#4A2C40]/20" onClick={() => {
            trackAddToCart();
            window.open('https://quickupstart.com//cart/51709750313242:1', '_blank');
          }} data-id="element-90">
              Get The Luteal Survival Kit
            </Button>

            <p className="text-xs text-center text-[#4A2C40]/50" data-id="element-91">
              Secure payment • Instant PDF download
            </p>
          </div>
        </div>
      </div>

      {/* Final Promise */}
      <div className="mt-16 text-center max-w-2xl mx-auto" data-id="element-92">
        <h4 className="text-xl font-serif font-bold text-[#4A2C40] mb-4" data-id="element-93">
          The Promise
        </h4>
        <p className="text-lg text-[#4A2C40]/80 mb-8" data-id="element-94">
          You'll stop losing the same week every month by switching from
          willpower to defaults.
        </p>
        <p className="text-sm font-medium text-[#4A2C40]" data-id="element-95">
          Start with the 10-Minute Rescue Protocol tonight.
        </p>
      </div>
    </section>;
}